// Home.jsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import BannerImg from "../Assest/images/banner-img/tgvl.jpeg";
import BannerImg1 from "../Assest/images/banner-img/tgvl1.jpeg";
import BannerImg2 from "../Assest/images/banner-img/tgvl2.jpeg";
import BannerImg3 from "../Assest/images/banner-img/tgvl3.jpeg";
// import BannerImg4 from "../Assest/images/banner-img/tgvl3.jpeg";
import ShopByCategory from "./ShopByCategory";
import ShopByBrands from "./PopularProducts";
import TitanEyeplusHome from "./TitanEyeplusHome";
import NewCurations from "./NewCurations";
import TrendingSearches from "./TrendingSearches";
import OurBestsellers from "./OurBestsellers";
// import ShopCollections from "./ShopByCollection";
// import FeaturedCollections from "./FeaturedCollections";
import JoinTheHype from "./JoinTheHype";
// import VideoSlider from "../components/VideoSlider";
// import BlogSection from "../components/BlogSection";
import TestimonialSlider from "../components/TestimonialSlider";
import AccordionSection from "../components/AccordionSection";
import ExclusiveDeals from "./ExclusiveDeals";

function Home() {
  return (
    <div>
      {/* HERO BANNER */}
      <section id="herobanner">
  <Swiper
    modules={[Pagination, Autoplay]}
    slidesPerView={1}
    loop={true}
    speed={1000}
    autoplay={{ delay: 4000, disableOnInteraction: false }}
    pagination={{ clickable: true }}
    className="hero-slider"
  >
    {/* SLIDE 1 */}
    <SwiperSlide>
      <div
        className="hero-slide"
        style={{
          backgroundImage: `url(${BannerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "600px",
        }}
      />
    </SwiperSlide>

    {/* SLIDE 2 */}
    <SwiperSlide>
      <div
        className="hero-slide"
        style={{
          backgroundImage: `url(${BannerImg1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "600px",
        }}
      />
    </SwiperSlide>

    {/* SLIDE 3 */}
    <SwiperSlide>
      <div
        className="hero-slide"
        style={{
          backgroundImage: `url(${BannerImg2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "600px",
        }}
      />
    </SwiperSlide>
 {/* SLIDE 4 */}
    <SwiperSlide>
      <div
        className="hero-slide"
        style={{
          backgroundImage: `url(${BannerImg3})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "600px",
        }}
      />
    </SwiperSlide>
{/* SLIDE 5
    <SwiperSlide>
      <div
        className="hero-slide"
        style={{
          backgroundImage: `url(${BannerImg3})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "600px",
        }}
      />
    </SwiperSlide> */}
  </Swiper>
</section>

      <ExclusiveDeals />
      <ShopByBrands />
      <TitanEyeplusHome />
      <JoinTheHype />
      <NewCurations />
     

      <ShopByCategory />


      <TrendingSearches />
      {/* <TestimonialSlider /> */}
      {/* <VideoSlider /> */}
      {/* <AccordionSection /> */}
      <OurBestsellers />


      {/* <ShopCollections />
      <FeaturedCollections />
      <JoinTheHype />
      <VideoSlider />
      <BlogSection />
     
      <AccordionSection /> */}
    </div>
  );
}

export default Home;
